import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';

import IconPlus from 'components/icons/IconPlus';
import IconCreditCard from 'components/icons/IconCreditCard';
import Section, {
  SectionHeader, SectionTitle, SectionBody, SectionBodyEmptyContent,
} from 'components/common/Section';
import Button from 'components/common/Button';
import CreditCardsItem from './CreditCardsItem';
import CreditCardsDialog from './CreditCardsDialog';

const styles = () => ({
  iconPlus: {
    width: 14,
    height: 14,
    marginRight: 10,
  },
  button: {
    marginLeft: 20,
  },
  iconCreditCard: {
    width: 20,
    height: 16,
  },
});

class CreditCards extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addDialogOpen: false,
    };

    this.onAddButtonClick = this.onAddButtonClick.bind(this);
    this.onAddDialogClose = this.onAddDialogClose.bind(this);
  }

  onAddButtonClick() {
    this.setState({ addDialogOpen: true });
  }

  onAddDialogClose() {
    this.setState({ addDialogOpen: false });
  }

  render() {
    const {
      classes,
      patient,
    } = this.props;

    return (
      <Section>
        <SectionHeader>
          <SectionTitle>
            Credit Card
          </SectionTitle>
          <Button
            className={classes.button}
            variant="raised"
            disabled={!patient}
            onClick={this.onAddButtonClick}
          >
            <IconPlus className={classes.iconPlus} />
            Add
          </Button>
        </SectionHeader>
        <SectionBody padding="none">
          {(!patient || patient['Credit Card'].length === 0
            || patient['Credit Card'].filter(item => item).length === 0) ? (
              <SectionBodyEmptyContent
                text="There are no credit cards yet"
                icon={(
                  <IconCreditCard className={classes.iconCreditCard} />
                )}
              />
            ) : (
              <Table>
                <TableBody>
                  {
                    patient['Credit Card'].map(item => (
                      <CreditCardsItem
                        key={item.ID}
                        {...{ 'Record Number': patient['Record Number'] }}
                        {...item}
                      />
                    ))
                  }
                </TableBody>
              </Table>
            )}
        </SectionBody>
        {patient !== null &&
          <CreditCardsDialog
            open={this.state.addDialogOpen}
            onClose={this.onAddDialogClose}
            {...{ 'User Record Number': patient['Record Number'] }}
          />
        }
      </Section>
    );
  }
}

CreditCards.propTypes = {
  patient: PropTypes.shape({
    'Credit Card': PropTypes.arrayOf(PropTypes.shape({
      ID: PropTypes.number.isRequired,
    })),
  }),
  classes: PropTypes.shape({
    iconPlus: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    iconCreditCard: PropTypes.string.isRequired,
  }).isRequired,
};

CreditCards.defaultProps = {
  patient: null,
};

export default withStyles(styles)(CreditCards);



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/CreditCards/CreditCards.js